import { Navigate } from 'react-router';

/**
 * /app/settings — legacy redirect.
 *
 * The card-grid index page (Members & invites · Workspace · Billing &
 * plan · Integrations) was retired 2026-05. Three of the four cards
 * pointed to "coming soon" stubs; only Members was real. Top-nav now
 * links to "Team" (→ /app/settings/members) and Billing will get its
 * own top-level tab when it ships.
 *
 * We keep this component instead of removing the route entirely so any
 * existing bookmarks or in-app links (e.g. the old "Back to settings"
 * affordance from Members.tsx) still resolve cleanly.
 */
export default function Settings() {
  return <Navigate to="/app/settings/members" replace />;
}
